import { Dispatch, SetStateAction } from 'react';
import { IListObjectInitialState } from '../TransferList';

interface CommonHandlerParams<T> {
    props: {
        objectLists: IListObjectInitialState<T>;
        setObjectLists: Dispatch<Partial<IListObjectInitialState<T>>>;
        added: T[];
        setAdded: Dispatch<SetStateAction<T[]>>;
        removed: T[];
        setRemoved: Dispatch<SetStateAction<T[]>>;
        checked: T[];
        setChecked: Dispatch<SetStateAction<T[]>>;
        filterObjects: (...args: any[]) => T[];
    };
    type?: string;
    name: string;
    utils: IBaseListUtils<T>;
}

interface IBaseListUtils<T> {
    intersection: (a: T[], b: T[]) => T[];
    not: (a: T[], b: T[]) => T[];
}

export const createHandleAdd = <T>({
    props,
    type,
    name,
    utils,
}: CommonHandlerParams<T>) => {
    const {
        objectLists: {
            assignedObjects,
            unassignedObjects,
            filteredAssignedObjects,
            originalAssignedObjects,
        },
        setObjectLists,
        checked,
        setChecked,
        added,
        setAdded,
        removed,
        setRemoved,
        filterObjects,
    } = props;

    const { not } = utils;

    return (toAdd: T[]) => {
        setObjectLists({
            assignedObjects: assignedObjects.concat(toAdd),
            filteredAssignedObjects: filteredAssignedObjects.concat(
                type
                    ? filterObjects(toAdd, type, name)
                    : filterObjects(toAdd, name)
            ),
            unassignedObjects: not(unassignedObjects, toAdd),
        });
        setChecked(not(checked, toAdd));
        setAdded(added.concat(not(toAdd, originalAssignedObjects)));
        setRemoved(not(removed, toAdd));
    };
};

export const createHandleRemove = <T>({
    props,
    type,
    name,
    utils,
}: CommonHandlerParams<T>) => {
    const {
        objectLists: {
            assignedObjects,
            unassignedObjects,
            filteredAssignedObjects,
            originalAssignedObjects,
        },
        setObjectLists,
        checked,
        setChecked,
        added,
        setAdded,
        removed,
        setRemoved,
        filterObjects,
    } = props;
    const { intersection, not } = utils;

    return (toRemove: T[]) => {
        setObjectLists({
            assignedObjects: not(assignedObjects, toRemove),
            filteredAssignedObjects: not(filteredAssignedObjects, toRemove),
            unassignedObjects: unassignedObjects.concat(
                type
                    ? filterObjects(toRemove, type, name)
                    : filterObjects(toRemove, name)
            ),
        });
        setChecked(not(checked, toRemove));
        setRemoved(
            removed.concat(intersection(toRemove, originalAssignedObjects))
        );
        setAdded(not(added, toRemove));
    };
};
